export type FileSizeUnit = 'Bytes' | 'KB' | 'MB' | 'GB' | 'TB';

export interface FormattedFileSize {
  value: number;
  unit: FileSizeUnit;
  formatted: string;
}

const FILE_SIZE_UNITS: FileSizeUnit[] = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
const BYTES_PER_UNIT = 1024;

export const formatFileSize = (bytes: number): FormattedFileSize => {
  if (!Number.isFinite(bytes) || bytes < 0) {
    bytes = 0;
  }
  if (bytes === 0) {
    return {
      value: 0,
      unit: 'Bytes',
      formatted: '0 Bytes'
    };
  }

  const rawUnitIndex = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_UNIT));
  const unitIndex = Math.max(0, Math.min(rawUnitIndex, FILE_SIZE_UNITS.length - 1));
  const unit = FILE_SIZE_UNITS[unitIndex];
  const value = parseFloat((bytes / Math.pow(BYTES_PER_UNIT, unitIndex)).toFixed(2));

  return {
    value,
    unit,
    formatted: `${value} ${unit}`
  };
};

export const bytesToMB = (bytes: number): number => {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return 0;
  }
  return bytes / (BYTES_PER_UNIT * BYTES_PER_UNIT);
};

export const mbToBytes = (mb: number): number => {
  if (!Number.isFinite(mb) || mb < 0) {
    return 0;
  }
  return mb * BYTES_PER_UNIT * BYTES_PER_UNIT;
};
